import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { triggerApkDownload } from "@/lib/site";
import Navbar from "@/components/Navbar";
import AppHeader from "@/components/AppHeader";
import VideoBanner from "@/components/VideoBanner";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import InstallGuide, { ApkModal } from "@/components/InstallGuide";
import BookingForm from "@/components/BookingForm";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MobileCtaBar from "@/components/MobileCtaBar";

function Site() {
    const [apkOpen, setApkOpen] = useState(false);

    const downloadAndGuide = useCallback(() => {
        triggerApkDownload();
        setApkOpen(true);
    }, []);

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        document.body.style.overflow = apkOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [apkOpen]);

    return (
        <div className="min-h-screen bg-paper" data-testid="azmthullah-app-root">
            <Navbar />
            <main>
                <AppHeader onDownload={downloadAndGuide} />
                <VideoBanner />
                <Marquee />
                <Services />
                <InstallGuide onDownload={downloadAndGuide} />
                <BookingForm onDownload={downloadAndGuide} />
                <ContactSection />
            </main>
            <Footer />
            <MobileCtaBar onDownload={downloadAndGuide} />
            <ApkModal open={apkOpen} onClose={() => setApkOpen(false)} onDownload={downloadAndGuide} />
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default function App() {
    return (
        <LanguageProvider>
            <Site />
        </LanguageProvider>
    );
}
